module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _c('h4', [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioValue),
      expression: "radioValue"
    }],
    attrs: {
      "type": "radio",
      "id": "radio1",
      "name": "radios",
      "value": "illegalCar",
      "checked": ""
    },
    domProps: {
      "checked": _vm._q(_vm.radioValue, "illegalCar")
    },
    on: {
      "change": function($event) {
        _vm.radioValue = "illegalCar"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radio1"
    }
  }, [_vm._v("違規車輛")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioValue),
      expression: "radioValue"
    }],
    attrs: {
      "type": "radio",
      "id": "radio2",
      "name": "radios",
      "value": "legalCar"
    },
    domProps: {
      "checked": _vm._q(_vm.radioValue, "legalCar")
    },
    on: {
      "change": function($event) {
        _vm.radioValue = "legalCar"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radio2"
    }
  }, [_vm._v("未違規車輛")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioValue),
      expression: "radioValue"
    }],
    attrs: {
      "type": "radio",
      "id": "radio3",
      "name": "radios",
      "value": "allCar"
    },
    domProps: {
      "checked": _vm._q(_vm.radioValue, "allCar")
    },
    on: {
      "change": function($event) {
        _vm.radioValue = "allCar"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radio3"
    }
  }, [_vm._v("全部車輛")])]), _c('hr'), _c('div', {
    staticClass: "custom-functions-wrapper"
  }, _vm._l((_vm.reportFunctions), function(func) {
    return _c('div', {
      staticClass: "custom-function"
    }, [_c('h5', [_vm._v(" " + _vm._s(func.name))]), _c('hr'), _c('QueryFilter', {
      attrs: {
        "showDate": func.query_by_date,
        "showEventType": false,
        "showSystem": false,
        "showFilterButton": false
      },
      on: {
        "report": function($event) {
          return _vm.report($event, func.function_name, func.name, func.query_by_date)
        }
      }
    })], 1)
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('kbd', [_vm._v("區間速率報表")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "text-info"
  }, [_c('strong', [_vm._v("明細報表輸出類型")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d0c7ede","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/ReportExport/CustomReport.vue
// module id = 1466
// module chunks = 1